import { render } from "./SummaryPackage.vue?vue&type=template&id=6b907c5b&scoped=true&ts=true&lang=pug"
import script from "./SummaryPackage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SummaryPackage.vue?vue&type=script&lang=ts&setup=true"

import "./SummaryPackage.vue?vue&type=style&index=0&id=6b907c5b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b907c5b"]])

export default __exports__